import { render, staticRenderFns } from "./classSelecter.vue?vue&type=template&id=0a7746eb&scoped=true&"
import script from "./classSelecter.vue?vue&type=script&lang=js&"
export * from "./classSelecter.vue?vue&type=script&lang=js&"
import style0 from "./classSelecter.vue?vue&type=style&index=0&id=0a7746eb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7746eb",
  null
  
)

export default component.exports